module.exports = __webpack_public_path__ + "static/media/gal.f334bfe6.jpg";